import formInputFieldMixin from './formInputField';
import formInputTextPropsMixin from './formInputTextProps';

export default {
  mixins: [formInputFieldMixin, formInputTextPropsMixin],
  methods: {
    onInput (event) {
      this.$emit('input', event.target.value);
    },
  },
};
